import { render, staticRenderFns } from "./cap-star-score.vue?vue&type=template&id=44986d1d&scoped=true&lang=pug&"
import script from "./cap-star-score.vue?vue&type=script&lang=js&"
export * from "./cap-star-score.vue?vue&type=script&lang=js&"
import style0 from "./cap-star-score.vue?vue&type=style&index=0&id=44986d1d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44986d1d",
  null
  
)

export default component.exports